export const ItemTypes = {
  GRID_ITEM: 'grid-item',
};
